import React, { useState } from 'react';
import './Header.scss';
import logo from '../Assets/Images/ArtifitLogo.png';
import AnchorLink from 'react-anchor-link-smooth-scroll';

function Header() {
  const [isChecked, setIsChecked] = useState(false);
  const handleLiClick = () => setIsChecked(false);

  const isHomePage = window.location.pathname === '/' || window.location.pathname === '/index.html';
  const isGravity4AIPage = window.location.pathname === '/gravity4ai';
  const isEnergyAIPage = window.location.pathname === '/energyai';
  const isDigitalnaKancelarijaPage = window.location.pathname === '/digitalnakancelarija';
  const isEnterpriseArchitecturePage = window.location.pathname.toLowerCase() === '/enterprisearchitecture';
  const isPowerPlayPage = window.location.pathname.toLowerCase() === '/powerplay';

  const showNav = isHomePage || isGravity4AIPage || isEnergyAIPage || isDigitalnaKancelarijaPage || isEnterpriseArchitecturePage || isPowerPlayPage;

  return (
    <>
      <div className='header'>
        {/* Logo */}
        <a className='a-logo' href="https://www.artifit.rs" rel="noreferrer">
          <img className='logo' src={logo} alt="Artifit" />
        </a>

        {/* Right side — nav + Contact us */}
        <div className="header-right">
          {showNav && (
            <ul className="nav-items">
              {isHomePage ? (
                <>
                  <li><AnchorLink href='#link-1'>About us</AnchorLink></li>
                  <li><AnchorLink href='#link-2'>Services</AnchorLink></li>
                  <li><AnchorLink href='#link-3'>Products</AnchorLink></li>
                  <li><AnchorLink href='#link-5'>References</AnchorLink></li>
                </>
              ) : (
                <>
                  <li><a href='/#link-1'>About us</a></li>
                  <li><a href='/#link-2'>Services</a></li>
                  <li><a href='/#link-3'>Products</a></li>
                  <li><a href='/#link-5'>References</a></li>
                </>
              )}
            </ul>
          )}
          {showNav && (
            <a href="mailto:office@artifit.rs" rel="noreferrer" target="_blank" className='header-contact-btn'>Contact us</a>
          )}
        </div>

        {/* Mobile hamburger */}
        <div className="mobile-nav">
          <input
            id="menu-toggle"
            type="checkbox"
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          />
          <label className='menu-button-container' htmlFor="menu-toggle">
            <div className='menu-button'></div>
          </label>
        </div>
      </div>

      {/* Mobile fullscreen overlay — van headera */}
      <div className={`nav${isChecked ? ' nav-open' : ''}`}>
        <div className="nav-wrapper">
          {showNav && (
            <ul className="nav-items-wrapper">
              {isHomePage ? (
                <>
                  <li onClick={handleLiClick}><AnchorLink href='#link-1'>About us</AnchorLink></li>
                  <li onClick={handleLiClick}><AnchorLink href='#link-2'>Services</AnchorLink></li>
                  <li onClick={handleLiClick}><AnchorLink href='#link-3'>Products</AnchorLink></li>
                  <li onClick={handleLiClick}><span className="nav-placeholder">References</span></li>
                </>
              ) : (
                <>
                  <li onClick={handleLiClick}><a href='/#link-1'>About us</a></li>
                  <li onClick={handleLiClick}><a href='/#link-2'>Services</a></li>
                  <li onClick={handleLiClick}><a href='/#link-3'>Products</a></li>
                  <li onClick={handleLiClick}><a href='/#link-5'>References</a></li>
                </>
              )}
              <li onClick={handleLiClick}><a href="mailto:office@artifit.rs" rel="noreferrer" target="_blank">Contact us</a></li>
            </ul>
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
